import { render } from "./Members.vue?vue&type=template&id=3b3869af&scoped=true"
import script from "./Members.vue?vue&type=script&lang=js"
export * from "./Members.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3b3869af"

export default script